
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setClientId, setFinancialYear } from './../store/appSlice';
import { getImportSourceLabel } from '../utils/tradeImport';

const FINANCIAL_YEAR_OPTIONS = ['2021-2022', '2022-2023', '2023-2024', '2024-2025', '2025-2026', '2026-2027'];

const Dropdowns = ({ className = '' }) => {
  const dispatch = useDispatch();

  const { clientId, financialYear } = useSelector((state) => state.app);
  const { clients, loading, error } = useSelector((state) => state.clients);
  const profile = useSelector((state) => state.user.profile);
  const userClientOptions = profile?.clientAccesses?.length > 0
    ? profile.clientAccesses.map((clientAccess) => ({
      value: clientAccess.clientId,
      brokerPreset: clientAccess.brokerPreset || null,
      label: `${clientAccess.clientId} - ${clientAccess.brokerPreset ? getImportSourceLabel(clientAccess.brokerPreset).replace(' preset', '') : 'No preset'}`,
    }))
    : profile?.clientIds?.map((id) => ({ value: id, brokerPreset: null, label: `${id} - No preset` }));

  const activeClientOption = userClientOptions?.find((option) => option.value === clientId);

  return (
    <div className={`dropdowns-container ${className}`.trim()}>
      <label className="dropdown-field">
        <span>Client</span>
        <select aria-label="Select client" onChange={(e) => dispatch(setClientId(e.target.value))} value={clientId}>
          <option value="">Select Client ID</option>
          {userClientOptions && userClientOptions.length > 0 ? (
            userClientOptions.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))
          ) : loading ? (
            <option value="">Loading...</option>
          ) : error ? (
            <option value="">Error loading clients</option>
          ) : (
            clients.map((client) => (
              <option key={client.id} value={client.id}>{client.name || client.id}</option>
            ))
          )}
        </select>
        {activeClientOption ? (
          <small className={`dropdown-field__meta${activeClientOption.brokerPreset ? '' : ' dropdown-field__meta--muted'}`}>
            {activeClientOption.brokerPreset
              ? `Import source: ${getImportSourceLabel(activeClientOption.brokerPreset)}`
              : 'Import source: no saved preset'}
          </small>
        ) : null}
      </label>
      <label className="dropdown-field">
        <span>Financial Year</span>
        <select aria-label="Select financial year" onChange={(e) => dispatch(setFinancialYear(e.target.value))} value={financialYear}>
          <option value="">Select Financial Year</option>
          {FINANCIAL_YEAR_OPTIONS.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default Dropdowns;
